import cookieModal from './cookies_panel'

let url = window.location.href;
let utm = url.split("?");
if(utm[1]){
    console.log(utm[1]);
    cookieModal.methods.setUtmCookie('utm', utm[1], 15)
}else {
    cookieModal.methods.setUtmCookie('utm', 'home', 15)
}
